module.exports = __webpack_public_path__ + "static/jewelbotsato2018-3267550ec6f309a62338df9a84aa6b8a.jpeg";